module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-regular.76e766753becb2b7da20.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.woff2
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.woff2
// module chunks = styles